import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=133c35e4&scoped=true&"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=133c35e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c35e4",
  null
  
)

export default component.exports